import React from 'react';

const BackIcon = ({ className }): JSX.Element => (
  <div role="presentation" className={className}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.527"
      height="16.286"
      viewBox="0 0 18.527 16.286"
    >
      <path
        fill="#fff"
        d="M19.5-45.02a1.247 1.247 0 0 0-1.247-1.247H5.382l5.068-4.725a1.247 1.247 0 0 0 .4-1.208 1.247 1.247 0 0 0-.869-.929 1.247 1.247 0 0 0-1.232.317l-7.384 6.879a1.247 1.247 0 0 0-.4.912 1.247 1.247 0 0 0 .4.912l7.383 6.881a1.247 1.247 0 0 0 1.762-.061 1.247 1.247 0 0 0-.061-1.762l-5.067-4.722h12.867A1.247 1.247 0 0 0 19.5-45.02z"
        transform="translate(-.968 53.178)"
      />
    </svg>
  </div>
);

export default BackIcon;
